import React from 'react'

const MessageWindow = ({children, messageUserAvatar, messageUserName, lastMessage}) => {
    return (
        <div className="message-window">
            <div className="window-heading">
            <>
                <div className="avater">
                    <img src={messageUserAvatar ? messageUserAvatar : "./img/avatar.png"} alt="customer" />
                </div>
                <div className="customer-details" style={{display: "flex", flexDirection: 'column', justifyContent: 'center'}}>              
                    <h4 style={{marginBottom: 0}}>{messageUserName && messageUserName}</h4>
                    <p style={{marginBottom: 0}}>{lastMessage && lastMessage}</p>               
                </div>
            </>
            </div>
            {children}
        </div>
    )
}

export default MessageWindow
